/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown>, email: NonNullable<unknown> }} Creator_Auth_Error_License_TextInputs */

const en_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There was an issue verifying your license: ${i?.message}
Please contact support for more help: ${i?.email}`)
};

const fr_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un probleme est survenu lors de la verification de votre licence : ${i?.message}
Veuillez contacter le support pour obtenir de l'aide : ${i?.email}`)
};

const de_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bei der Überprüfung Ihrer Lizenz ist ein Problem aufgetreten: ${i?.message}
Bitte kontaktieren Sie den Support für weitere Hilfe: ${i?.email}`)
};

const it_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si è verificato un problema durante la verifica della tua licenza: ${i?.message}
Contatta l'assistenza per ulteriore assistenza: ${i?.email}`)
};

const ru_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Возникла проблема при проверке вашей лицензии: ${i?.message}
Для получения дополнительной помощи обратитесь в службу поддержки: ${i?.email}`)
};

const es_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hubo un problema al verificar su licencia: ${i?.message}
Para obtener más ayuda, póngase en contacto con el servicio de asistencia: ${i?.email}`)
};

const zh_cn2_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`验证您的许可证时出现问题：${i?.message}

请联系客服获取更多帮助：${i?.email}`)
};

const ja_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ライセンスの確認中に問題が発生しました: ${i?.message}
詳細については、サポートにお問い合わせください: ${i?.email}`)
};

const hi_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपके लाइसेंस को सत्यापित करने में समस्या आ रही है: ${i?.message}
अधिक सहायता के लिए कृपया सहायता टीम से संपर्क करें: ${i?.email}`)
};

const pt_pt2_creator_auth_error_license_text = /** @type {(inputs: Creator_Auth_Error_License_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocorreu um problema ao verificar sua licença: ${i?.message}
Entre em contato com o suporte para obter mais ajuda: ${i?.email}`)
};

/**
* | output |
* | --- |
* | "There was an issue verifying your license: {message} Please contact support for more help: {email}" |
*
* @param {Creator_Auth_Error_License_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_auth_error_license_text = /** @type {((inputs: Creator_Auth_Error_License_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Auth_Error_License_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_auth_error_license_text(inputs)
	if (locale === "de") return de_creator_auth_error_license_text(inputs)
	if (locale === "it") return it_creator_auth_error_license_text(inputs)
	if (locale === "ru") return ru_creator_auth_error_license_text(inputs)
	if (locale === "es") return es_creator_auth_error_license_text(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_auth_error_license_text(inputs)
	if (locale === "ja") return ja_creator_auth_error_license_text(inputs)
	if (locale === "hi") return hi_creator_auth_error_license_text(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_auth_error_license_text(inputs)
	return en_creator_auth_error_license_text(inputs)
});